module.exports = __webpack_public_path__ + "img/kong-plugins.ef5e4dc3.svg";